export default "__VITE_ASSET__CbENItd7__"